import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-unificator/services';
import { StaticContentService } from './static-content.service';
import { Observable, of } from 'rxjs';
import { filter, first, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { ThemeService } from './theme.service';
import { GamesService } from './games/games.service';
import { AbTestService } from '../ab-test/ab-test.service';
import { AB_TEST_LIST } from '../ab-test/ab-test.data';
import { CustomFlowData } from '../shared/interfaces/custom-flow-data-interface';

export const CUSTOM_FLOW_PARAM = 'game';
const PARTNERS = ['170116'];

@Injectable({
  providedIn: 'root',
})
export class CustomUserFlowService {
  private _cookie = inject(CookieService);
  private _static = inject(StaticContentService);
  private _theme = inject(ThemeService);
  private _games = inject(GamesService);
  private _ab = inject(AbTestService);


  private _customFlowData$: Observable<CustomFlowData> =
    this._ab.loadABTest$('CUSTOM_FLOW').pipe(
      first(),
      filter(abTest => (PARTNERS.includes(this._cookie.get('id_id')) ||
          AB_TEST_LIST.CUSTOM_FLOW.resolvedValue === AB_TEST_LIST.CUSTOM_FLOW.abTestGroupIds.V2) &&
        this._cookie.check(CUSTOM_FLOW_PARAM)),
      switchMap(() => this._static.item({ slug: '21bit-custom-flow' })),
      filter(list => !!list),
      map(list => list.map(item => ({
        ...item,
        FlowData: Object.values(item?.FlowData),
      }))),
      map(list => list.map(item => ({
        ...item,
        FlowData: item?.FlowData.map(dataItem => ({
          ...dataItem,
          payment: dataItem?.payment.split(','),
          imgSlug: this._convertStringToCamelCase(dataItem?.landing),
        })),
      }))[0]),
      map(list => {
        const findLanding = list?.FlowData?.find(flowData => this._cookie.get(CUSTOM_FLOW_PARAM).includes(flowData?.game));
        return {
          ...findLanding,
          image: list[findLanding?.imgSlug],
          theme: Number(findLanding?.theme),
          game$: findLanding ? this._games.getGameByExternalId(findLanding?.gameExternalId) : of({}),
        };
      }),
      tap((list) => this._theme.setTheme(list?.theme)),
      shareReplay(1),
    );

  get customFlowData$(): Observable<CustomFlowData> {
    return this._customFlowData$;
  }

  private _convertStringToCamelCase(str: string) {
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }
}
